import { useCallback } from "react";

export default function useAttendanceActions({
  currentDate,
  currentMonth,
  currentYear,
  dailyAttendance,
  filteredStudents,
  selectedIds,
  setActiveTab,
  setCurrentDate,
  setCurrentMonth,
  setCurrentYear,
  setDailyAttendance,
  setSelectedIds,
}) {
  const changeDate = (days) => {
    const date = new Date(currentDate);
    date.setDate(date.getDate() + days);
    setCurrentDate(date.toISOString().slice(0, 10));
  };

  const changeMonth = (offset) => {
    const [year, month] = currentMonth.split("-").map(Number);
    const date = new Date(year, month - 1 + offset, 1);
    const newYear = date.getFullYear();
    const newMonth = String(date.getMonth() + 1).padStart(2, "0");
    setCurrentMonth(`${newYear}-${newMonth}`);
  };

  const changeYear = (offset) => {
    const newYear = parseInt(currentYear, 10) + offset;
    setCurrentYear(newYear.toString());
  };

  const handleStatusChange = (id, status) => {
    setDailyAttendance((prev) => ({ ...prev, [id]: status }));
  };

  const handleSelectAll = () => {
    setSelectedIds((prevSelected) => {
      if (prevSelected.length === filteredStudents.length) {
        return [];
      }
      return filteredStudents.map((student) => student.id);
    });
  };

  const handleSelectRow = useCallback((id) => {
    setSelectedIds((prev) => {
      if (prev.includes(id)) {
        return prev.filter((selectedId) => selectedId !== id);
      }
      return [...prev, id];
    });
  }, [setSelectedIds]);

  const handleBulkStatusChange = (status) => {
    if (selectedIds.length === 0) return;
    const newAttendance = { ...dailyAttendance };
    selectedIds.forEach((id) => {
      newAttendance[id] = status;
    });
    setDailyAttendance(newAttendance);
  };

  const handleClearSelection = () => {
    if (selectedIds.length > 0) {
      setDailyAttendance((prev) => {
        const next = { ...prev };
        selectedIds.forEach((id) => {
          next[id] = "none";
        });
        return next;
      });
    }
    setSelectedIds([]);
  };

  const handleYearMonthClick = (monthIndex) => {
    const monthStr = String(monthIndex).padStart(2, "0");
    setCurrentMonth(`${currentYear}-${monthStr}`);
    setActiveTab("monthly");
  };

  const handleJumpToDaily = (dateStr) => {
    setCurrentDate(dateStr);
    setActiveTab("daily");
  };

  return {
    changeDate,
    changeMonth,
    changeYear,
    handleStatusChange,
    handleSelectAll,
    handleSelectRow,
    handleBulkStatusChange,
    handleClearSelection,
    handleYearMonthClick,
    handleJumpToDaily,
  };
}
